export default {
    methods: {
        isValid(value, type) {
            const regexes = {
                coordinates: /^-?\d+(\.\d*)?$/,
                phone: /^(?!-)(?!.*--)(?!.*\(\s*\))(?:\+|\(\+)[0-9\d()\-\s]*$/,
                email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/,
                website: /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/\S*)?$/
            };
            
            if (type === 'email' && value) {
                let separator = value.includes(",") ? "," : value.includes(";") ? ";" : null;
            
                if (separator) {
                    return value.split(separator).every(email => regexes.email.test(email.trim()));
                }

                return regexes.email.test(value.trim());
            }

            return regexes[type] ? regexes[type].test(value) : false;
        },

        getAllowedPlusPositions(value) {
            // Only allow + at the start, or as the second char if the first is (
            let allowedPlusPositions = [];

            if (value.startsWith('+')) allowedPlusPositions.push(0);
            if (value[0] === '(' && value[1] === '+') allowedPlusPositions.push(1);
            
            return allowedPlusPositions;
        },

        cleanPhoneString(value) {
            if (!value) return '';

            // Use helper to get allowed + positions
            const allowedPlusPositions = this.getAllowedPlusPositions(value);

            // Remove all + except those in allowed positions
            value = value
                .split('')
                .filter((char, idx) => char !== '+' || allowedPlusPositions.includes(idx))
                .join('');

            // Array of [regex, replacement] for all simple replacements
            const rules = [
                [/\(\s*[\+\-]+\s*\)/g, ''],    // Remove parentheses containing only "+" or "-" (with optional spaces)
                [/[^\d()+\- ]/g, ''],          // Remove all characters except digits, parentheses, plus, minus, and space
                [/\++/g, '+'],                 // Replace multiple consecutive "+" with a single "+"
                [/-+/g, '-'],                  // Replace multiple consecutive "-" with a single "-"
                [/[\+\-]+$/, ''],              // Remove "+" or "-" at the end
                [/\s+/g, ' '],                 // Replace multiple spaces with a single space
                [/^-+/, '']                    // Remove "-" at the start
            ];

            return rules.reduce((acc, [regex, rep]) => acc.replace(regex, rep), value).trim();
        },

        balanceParentheses(str) {
            // Remove all empty parentheses
            str = str.replace(/(\(\))/g, '');

            // Remove unbalanced parentheses
            let result = '';
            let stack = [];

            for (let i = 0; i < str.length; i++) {
                const char = str[i];
                
                if (char === '(') {
                    stack.push(result.length);
                    result += char;
                } else if (char === ')') {
                    if (stack.length > 0) {
                        stack.pop();
                        result += char;
                    }
                    // else: skip this unmatched ')'
                } else {
                    result += char;
                }
            }

            // Remove any unmatched '(' left in the stack
            if (stack.length > 0) {
                let arr = result.split('');

                while (stack.length) {
                    arr.splice(stack.pop(), 1);
                }

                result = arr.join('');
            }

            return result;
        },

        formatPhoneOnBlur(value) {
            let cleanedValue = this.cleanPhoneString(value);
            cleanedValue = this.balanceParentheses(cleanedValue);

            return cleanedValue;
        },

        validatePhoneNumber(phone) {
            // Helper: checks if parentheses are balanced and in correct order
            const isParenthesesBalanced = () => {
                let balance = 0;

                for (const char of phone) {
                    if (char === '(') balance++;      // Increment for each opening parenthesis
                    if (char === ')') balance--;      // Decrement for each closing parenthesis
                    if (balance < 0) return false;    // More closing than opening at any point: invalid
                }

                return balance === 0;                 // Valid if all opened are closed
            };

            // Validate using regex rules (all other rules except balanced parentheses)
            // and check for balanced parentheses
            return this.isValid(phone, 'phone') && isParenthesesBalanced();
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/validationHelpers.js